import { useEffect } from 'react';

interface AutoFetchableQuery {
  hasNextPage: boolean;
  isFetching: boolean;
  isError: boolean;
  fetchNextPage: () => Promise<unknown>;
}

/**
 * Drives a LEK/cursor chain automatically: after each page
 * settles, fetch the next while `when` holds. Stops on error (callers offer
 * Retry, which resumes the chain) and guards on isFetching so pages never
 * overlap. Callers keep their own comments on the enabling condition
 * (terms: always-until-exhausted; client-categorisation:
 * only-while-last-page-empty).
 */
export const useAutoFetchNextPage = ({ hasNextPage, isFetching, isError, fetchNextPage }: AutoFetchableQuery, when: boolean): void => {
  useEffect(() => {
    if (when && hasNextPage && !isFetching && !isError) void fetchNextPage();
  }, [when, hasNextPage, isFetching, isError, fetchNextPage]);
};
